import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatDate } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { MagnifyingGlass } from "@phosphor-icons/react";

export default function DocumentsPage() {
  const [docs, setDocs] = useState([]);
  const [matters, setMatters] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    (async () => {
      const [d, m] = await Promise.all([api.get("/documents"), api.get("/matters")]);
      setDocs(d.data); setMatters(m.data);
    })();
  }, []);

  const matterMap = useMemo(() => Object.fromEntries(matters.map((m) => [m.id, m])), [matters]);
  const filtered = docs.filter((d) => {
    const s = q.toLowerCase();
    return !s || [d.name, d.doc_type, matterMap[d.matter_id]?.title, matterMap[d.matter_id]?.reference].some((v) => (v || "").toLowerCase().includes(s));
  });

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <div className="text-[10px] tracking-[0.25em] uppercase text-slate-500 mb-1">Records</div>
          <h2 className="font-serif-brand text-3xl">Documents</h2>
          <p className="text-xs text-slate-500 mt-1">Metadata registry — actual files are stored on the firm's document management system.</p>
        </div>
        <div className="relative">
          <MagnifyingGlass size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input placeholder="Search documents…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-8 rounded-sm h-9 w-72 border-slate-300" />
        </div>
      </div>

      <div className="border border-slate-200 bg-white rounded-sm">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
            <tr>
              <th className="text-left px-6 py-3 font-medium">Name</th>
              <th className="text-left px-6 py-3 font-medium">Type</th>
              <th className="text-left px-6 py-3 font-medium">Matter</th>
              <th className="text-left px-6 py-3 font-medium">Notes</th>
              <th className="text-left px-6 py-3 font-medium">Added</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200">
            {filtered.length === 0 && <tr><td colSpan="5" className="px-6 py-12 text-center text-slate-500">No documents.</td></tr>}
            {filtered.map((d) => (
              <tr key={d.id} className="hover:bg-slate-50">
                <td className="px-6 py-3 font-medium">{d.name}</td>
                <td className="px-6 py-3 text-slate-600">{d.doc_type}</td>
                <td className="px-6 py-3">
                  {matterMap[d.matter_id] ? (
                    <Link to={`/matters/${d.matter_id}`} className="hover:underline text-slate-600">
                      <span className="font-mono-num text-xs">{matterMap[d.matter_id].reference}</span> · {matterMap[d.matter_id].title}
                    </Link>
                  ) : "—"}
                </td>
                <td className="px-6 py-3 text-slate-500 text-xs">{d.notes || "—"}</td>
                <td className="px-6 py-3 text-slate-500">{formatDate(d.uploaded_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
